<template>
  <div>
    <div class="about">
      <div class="scroll-wrap">
        <img
          :src="msg.img"
          alt=""
          class="video-image"
        />
        <div class="video-introduce">
         {{msg.text}}
        </div>
      </div>
      <div class="header">
        <div class="back" @click="Retui"></div>
      </div>
      <div class="container">
        <div class="info">
          <div class="row">正在获取网红用户数据……</div>
        </div>
        <div class="form">
          <div class="box">
            <input
              type="text"
              placeholder="请输入姓名为主播PK"
              class="input"
              @click="del"
            />
          </div>
          <div class="submit" @click="zhuli">PK</div>
        </div>
      </div>
      <div class="gif-box">
        <div class="gif" >
            <img src="../assets/image/1.439be5dc.gif" alt=""/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      msg: {},
    };
  },
  // 页面加载完成
  mounted() {
    let msg = JSON.parse(localStorage.getItem("item"));
    this.msg = msg;
  },
  methods: {
        del(){
            document.querySelector(".input").value = "";
        },
        zhuli() { 
            let msg = JSON.parse(localStorage.getItem("item"));
            // 获取输入框的值
            let name = document.querySelector(".input").value;
            // 判断输入框是否为空
            if (name == "") {
                alert("请输入姓名");
                return;
            }
            let livestreamer = msg.name.replace(/\d+\./, "");
            document.querySelector(".row").innerHTML = `正在为${livestreamer}PK……`;
            setTimeout(() => {
                document.querySelector(".row").innerHTML = `姓名${name}PK主播${livestreamer}PK成功。请将本页面截屏后联系您的助手。`;
            }, 1000);

            document.querySelector(".gif-box").classList.add("show");
            setTimeout(() => {
                document.querySelector(".gif-box").classList.remove("show");
            }, 4000);
        },
        Retui() {
            this.$router.go(-1);
        },
  },
};
</script>

<style lang="less" scoped>
    .about {
      height: 100%;
    }

    .about .video {
      background: #000;
      display: block;
      height: 100%;
      width: 100%
    }

    .about .scroll-wrap {
      height: 100%;
      overflow: auto
    }

    .about .scroll-wrap .video-image {
      border: none;
      display: block;
      margin: 0 auto;
      width: 100%
    }

    .about .scroll-wrap .video-introduce {
      color: #333;
      content: "viewport-units-buggyfill; padding: 2.667vw 2.667vw 40vw; font-size: 3.733vw";
      font-size: 3.733vw;
      font-weight: 500;
      padding: 2.667vw 2.667vw 40vw
    }

    .about .header {
      content: "viewport-units-buggyfill; padding: 7.067vw 1.667vw 0";
      left: 0;
      padding: 7.067vw 1.667vw 0;
      position: absolute;
      right: 0;
      top: 0;
      z-index: 1
    }

    .about .header .back {
      background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAiCAYAAAC5gzL5AAABKklEQVRIiaXWwUrDQBAG4F8vvoAv0Zs0tVVb04C2URC8+AA+vTfxVsG2+cvILg7DxuxOFgbabPox/NkMPSOJEWsJ4B2COKtlWF5gyb91GAvI2pYCdwZY/2ZaADyS3Cugjnu5wI3poNH7OcCM5FEBz/aeIWBOsuvrIAepSP4oYNV3b24G9X8d93VwUMDLUG72wrXJYJPz9PSXK/MUtrlnSGfQ5WaQQipzEtsSICK78ONPkpNSQOocwEWYSR2AL898EqQJny8BfABYFCuhpVZlIgFPSzOJVSvoGIZPMSJ1b477rQeRejDQYEd9G62BKg+CMDt0RnMPksoo+TrkpG8zWnuQVEZTD4IwnOLaa6gEQZizOuzGg6Qyqj2I1JNCvr2I1FtUxv7J2QB4PQE+dmOOGVopJwAAAABJRU5ErkJggg==) no-repeat 50%;
      background-size: 2.267vw 4.533vw;
      content: "viewport-units-buggyfill; width: 8vw; height: 8vw; background-size: 2.267vw 4.533vw";
      height: 8vw;
      width: 8vw
    }

    .about .container {
      background: #fff;
      border-radius: 3.2vw 3.2vw 0 0;
      bottom: 0;
      content: "viewport-units-buggyfill; padding-bottom: 3.2vw; border-radius: 3.2vw 3.2vw 0px 0px";
      left: 0;
      padding-bottom: 3.2vw;
      position: absolute;
      right: 0;
      z-index: 1
    }

    .about .container .info {
      content: "viewport-units-buggyfill; padding: 0 2.667vw";
      padding: 0 2.667vw
    }

    .about .container .info .row {
      color: #333;
      content: "viewport-units-buggyfill; line-height: 10.667vw; font-size: 3.733vw";
      font-size: 3.733vw;
      font-weight: 500;
      line-height: 10.667vw;
      text-align: center
    }

    .about .container .form {
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      content: "viewport-units-buggyfill; padding: 0 2.667vw";
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      padding: 0 2.667vw
    }

    .about .container .form .box {
      -webkit-box-flex: 1;
      border: 1px solid #999;
      border-radius: 1.6vw;
      content: "viewport-units-buggyfill; height: 9.333vw; border-radius: 1.6vw";
      -ms-flex: 1;
      flex: 1;
      height: 9.333vw
    }

    .about .container .form .box .input {
      background: none;
      border: none;
      -webkit-box-shadow: none;
      box-shadow: none;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      color: #999;
      content: "viewport-units-buggyfill; padding: 0 2.4vw; font-size: 4vw";
      display: block;
      font-size: 4vw;
      font-weight: 500;
      height: 100%;
      margin: 0;
      outline: none;
      padding: 0 2.4vw;
      width: 100%
    }

    .about .container .form .submit {
      -webkit-box-pack: center;
      -ms-flex-pack: center;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      background: linear-gradient(0deg, #ee85d7, #ba6fe6, #845bf5);
      border-radius: 4.4vw;
      color: #fff;
      content: "viewport-units-buggyfill; width: 26vw; height: 8.8vw; margin-left: 4.267vw; font-size: 4.8vw; border-radius: 4.4vw";
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      font-size: 4.8vw;
      font-weight: 700;
      height: 8.8vw;
      justify-content: center;
      margin-left: 4.267vw;
      width: 26vw
    }

    .about .gif-box {
      left: 0;
      opacity: 0;
      position: absolute;
      top: 50%;
      -webkit-transform: translateY(-50%);
      transform: translateY(-50%);
      -webkit-transition: opacity 2s;
      transition: opacity 2s;
      z-index: -1
    }
     .about .gif-box .gif img {
      width: 100%;
      height: 100%;
    }
    .about .gif-box .gif {
      content: "viewport-units-buggyfill; width: 100vw";
      display: block;
      width: 100vw
    }

    .about .gif-box.show {
      opacity: 1;
      z-index: 1
    }
</style>